// Rendering React components
import React from "react";
import { createRoot } from "react-dom/client";

import { getWidgetData } from "@utilities";

function renderSingleComponent(
  Component: React.FC<any>,
  container: HTMLElement,
  withWidgetConfig = true,
  ...defaultProps: unknown[]
): void {
  try {
    if (container) {
      const widgetData = withWidgetConfig ? getWidgetData(container) : {};
      const root = createRoot(container);

      const props = { ...defaultProps, ...widgetData };

      root.render(<Component {...props} />);
    }
  } catch (e) {
    console.error(e);
  }
}

function renderMultipleComponents(
  Component: React.FC<any>,
  // eslint-disable-next-line no-undef
  containers: NodeListOf<HTMLElement>,
  withWidgetConfig = true,
  ...defaultProps: unknown[]
): void {
  try {
    return Array.from(containers).forEach((container) => {
      const widgetData = withWidgetConfig ? getWidgetData(container) : {};
      const root = createRoot(container);

      const props = { container, ...defaultProps, ...widgetData };

      root.render(<Component {...props} />);
    });
  } catch (e) {
    console.error(e);
  }

  return null;
}

export default {
  single: renderSingleComponent,
  multiple: renderMultipleComponents,
};
